import React, {useCallback, useEffect, useMemo, useState} from 'react';
import _ from "lodash";
import Checkbox from "../../../../../components/checkbox";
import {useList} from "react-use";

import {Collapse} from 'react-collapse';

const getNumCheck = (value) => {
    let i = 0;
    _.filter(value,item => {
        if(item.check) i++;
    })
    return i;
}
function Inning(props) {
    const {selected} = props;
    const [isOpened, setIsOpened] = useState(false);
    const [oneInnings] = useList([
        {
            id: '82',
            name: '1回',
            check: false,
        },
        {
            id: '83',
            name: '2回',
            check: false,
        },
        {
            id: '84',
            name: '3回',
            check: false,
        },
    ])
    const [twoInnings] = useList([
        {
            id: '86',
            name: '4回',
            check: false,
        },
        {
            id: '87',
            name: '5回',
            check: false,
        },
        {
            id: '88',
            name: '6回',
            check: false,
        },
    ])
    const [threeInnings] = useList([
        {
            id: '90',
            name: '7回',
            check: false,
        },
        {
            id: '91',
            name: '8回',
            check: false,
        },
        {
            id: '92',
            name: '9回',
            check: false,
        },
    ])
    const [totalCondition, setTotalCondition] = useState({
        oneInnings: selected.oneInnings,
        twoInnings: selected.twoInnings,
        threeInnings: selected.threeInnings,
    })
    const [isCheckTotalOne, setIsCheckTotalOne] = useState(false);
    const [isCheckTotalTwo, setIsCheckTotalTwo] = useState(false);
    const [isCheckTotalThird, setIsCheckTotalThird] = useState(false);

    const oneList = useMemo(() => {
        return totalCondition.oneInnings.length > 0 ? totalCondition.oneInnings : oneInnings
    },[totalCondition.oneInnings])

    const twoList = useMemo(() => {
        return totalCondition.twoInnings.length > 0 ? totalCondition.twoInnings : twoInnings
    },[totalCondition.twoInnings])

    const threeList = useMemo(() => {
        return totalCondition.threeInnings.length > 0 ? totalCondition.threeInnings : threeInnings
    },[totalCondition.threeInnings])

    useEffect(() => {
        let countCheck = 0;
        oneList.forEach(item => {
            if(item.check === true) countCheck +=1;
        })
        if(countCheck === oneList.length) setIsCheckTotalOne(true);
    },[oneList])

    useEffect(() => {
        let countCheck = 0;
        twoList.forEach(item => {
            if(item.check === true) countCheck +=1;
        })
        if(countCheck === twoList.length) setIsCheckTotalTwo(true);
    },[twoList])

    useEffect(() => {
        let countCheck = 0;
        threeList.forEach(item => {
            if(item.check === true) countCheck +=1;
        })
        if(countCheck === threeList.length) setIsCheckTotalThird(true);
    },[threeList])

    useEffect(() => {
        props.onChange(totalCondition)
    }, [totalCondition])
    useEffect(() => {
        if (_.isEmpty(totalCondition.oneInnings)) {
            setIsCheckTotalOne(false)
            return;
        }
        if(totalCondition.oneInnings.length !== getNumCheck(totalCondition.oneInnings)) setIsCheckTotalOne(false)
    }, [totalCondition.oneInnings])
    useEffect(() => {
        if (_.isEmpty(totalCondition.twoInnings)) {
            setIsCheckTotalTwo(false);
            return;
        }
        if(totalCondition.twoInnings.length !== getNumCheck(totalCondition.twoInnings)) setIsCheckTotalTwo(false);
    }, [totalCondition.twoInnings])
    useEffect(() => {
        if (_.isEmpty(totalCondition.threeInnings)) {
            setIsCheckTotalThird(false);
            return;
        }
        if(totalCondition.threeInnings.length !== getNumCheck(totalCondition.threeInnings)) setIsCheckTotalThird(false);
    }, [totalCondition.threeInnings])

    const onClickTotalOne = useCallback(() => {
        setIsCheckTotalOne(!isCheckTotalOne);
        if (!isCheckTotalOne) {
            const arr = [];
            const cpList = [...oneInnings];
            cpList.forEach(i => {
                arr.push(i);
                i.check = true
            })
            setTotalCondition({
                oneInnings: arr,
                twoInnings: totalCondition.twoInnings.length > 0 ? totalCondition.twoInnings : twoInnings ,
                threeInnings: totalCondition.threeInnings.length > 0 ? totalCondition.threeInnings : threeInnings
            })
        } else {
            const cpList = [...oneInnings];
            cpList.forEach(i => {
                i.check = false
            })
            setTotalCondition({
                oneInnings: [],
                twoInnings: selected.twoInnings.length > 0 ? selected.twoInnings : twoInnings ,
                threeInnings: selected.threeInnings.length > 0 ? selected.threeInnings : threeInnings
            })
        }
    }, [isCheckTotalOne])

    const onCheckOne = useCallback((val) => {
        const cpList = [...totalCondition.oneInnings].length > 0 ? [...totalCondition.oneInnings] : oneInnings ;
        const i = _.findIndex(cpList, item => item.id === val.id);
        cpList[i].check = !val.check ? true : false;
        setTotalCondition({
            oneInnings: cpList,
            twoInnings: totalCondition.twoInnings.length > 0 ? totalCondition.twoInnings : twoInnings,
            threeInnings: totalCondition.threeInnings.length > 0 ? totalCondition.threeInnings : threeInnings,
        });
    })

    const onClickTotalTwo = useCallback(() => {
        setIsCheckTotalTwo(!isCheckTotalTwo);
        if (!isCheckTotalTwo) {
            const arr = [];
            const cpList = [...twoInnings];
            cpList.forEach(i => {
                arr.push(i);
                i.check = true
            })
            setTotalCondition({
                oneInnings: totalCondition.oneInnings.length > 0 ? totalCondition.oneInnings : oneInnings,
                twoInnings:  arr,
                threeInnings: totalCondition.threeInnings.length > 0 ? totalCondition.threeInnings : threeInnings
            })
        } else {
            const cpList = [...twoInnings];
            cpList.forEach(i => {
                i.check = false
            })
            setTotalCondition({
                oneInnings: totalCondition.oneInnings.length > 0 ? totalCondition.oneInnings : oneInnings,
                twoInnings:  [],
                threeInnings: totalCondition.threeInnings.length > 0 ? totalCondition.threeInnings : threeInnings
            })
        }

    }, [isCheckTotalTwo])

    const onCheckTwo = useCallback((val) => {
        const cpList = [...totalCondition.twoInnings].length > 0 ? [...totalCondition.twoInnings] : twoInnings ;
        const i = _.findIndex(cpList, item => item.id === val.id);
        cpList[i].check = !val.check ? true : false;
        setTotalCondition({
            oneInnings: totalCondition.oneInnings.length > 0 ? totalCondition.oneInnings : oneInnings,
            twoInnings: cpList,
            threeInnings: totalCondition.threeInnings.length > 0 ? totalCondition.threeInnings : threeInnings,
        });
    })

    const onClickTotalThird = useCallback(() => {
        setIsCheckTotalThird(!isCheckTotalThird);
        if (!isCheckTotalThird) {
            const arr = [];
            const cpList = [...threeInnings];
            cpList.forEach(i => {
                arr.push(i);
                i.check = true
            })
            setTotalCondition({
                oneInnings: totalCondition.oneInnings.length > 0 ? totalCondition.oneInnings : oneInnings,
                twoInnings:  totalCondition.twoInnings.length > 0 ? totalCondition.twoInnings : twoInnings,
                threeInnings: arr,
            })
        } else {
            const cpList = [...threeInnings];
            cpList.forEach(i => {
                i.check = false
            })
            setTotalCondition({
                oneInnings: totalCondition.oneInnings.length > 0 ? totalCondition.oneInnings : oneInnings,
                twoInnings:  totalCondition.twoInnings.length > 0 ? totalCondition.twoInnings : twoInnings,
                threeInnings: [],
            })
        }

    }, [isCheckTotalThird])

    const onCheckThird = useCallback((val) => {
        const cpList = [...totalCondition.threeInnings].length > 0 ? [...totalCondition.threeInnings] : threeInnings ;
        const i = _.findIndex(cpList, item => item.id === val.id);
        cpList[i].check = !val.check ? true : false;
        setTotalCondition({
            oneInnings: totalCondition.oneInnings.length > 0 ? totalCondition.oneInnings : oneInnings,
            twoInnings: totalCondition.twoInnings.length > 0 ? totalCondition.twoInnings : twoInnings,
            threeInnings: cpList,
        });
    })
    return (
        <div className='group-filter-item'>
          <div className={'open-collapse'}>
              <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                  <h4>イニング</h4>
                  <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
              </div>
              <Collapse isOpened={isOpened}>
                  <div>
                      <div className='search-main-advanced-checkbox'>
                          <label>
                              <Checkbox checked={isCheckTotalOne} onClick={onClickTotalOne}/>
                              1〜3回
                          </label>
                      </div>
                      <div className='search-main-analysis-child-item wrap-group'>
                          {oneList.map(item => {
                              return (
                                  <div key={item.id} className='search-main-advanced-checkbox'>
                                      <label>
                                          <Checkbox checked={item.check} onClick={() => onCheckOne(item)}/>
                                          {item.name}
                                      </label>
                                  </div>
                              )
                          })}
                      </div>
                      <div className='search-main-advanced-checkbox'>
                          <label>
                              <Checkbox checked={isCheckTotalTwo} onClick={onClickTotalTwo}/>
                              4〜6回
                          </label>
                      </div>
                      <div className='search-main-analysis-child-item wrap-group'>
                          {twoList.map(item => {
                              return (
                                  <div key={item.id} className='search-main-advanced-checkbox'>
                                      <label>
                                          <Checkbox checked={item.check} onClick={() => onCheckTwo(item)}/>
                                          {item.name}
                                      </label>
                                  </div>
                              )
                          })}
                      </div>
                      <div className='search-main-advanced-checkbox'>
                          <label>
                              <Checkbox checked={isCheckTotalThird} onClick={onClickTotalThird}/>
                              7〜9回
                          </label>
                      </div>
                      <div className='search-main-analysis-child-item wrap-group'>
                          {threeList.map(item => {
                              return (
                                  <div key={item.id} className='search-main-advanced-checkbox'>
                                      <label>
                                          <Checkbox checked={item.check} onClick={() => onCheckThird(item)}/>
                                          {item.name}
                                      </label>
                                  </div>
                              )
                          })}
                      </div>
                  </div>
              </Collapse>
          </div>
            <div className={'close-collapse'}>
                <div>
                    <h4>イニング</h4>
                </div>
                    <div>
                        <div className='search-main-advanced-checkbox'>
                            <label>
                                <Checkbox checked={isCheckTotalOne} onClick={onClickTotalOne}/>
                                1〜3回
                            </label>
                        </div>
                        <div className='search-main-analysis-child-item wrap-group'>
                            {oneList.map(item => {
                                return (
                                    <div key={item.id} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.check} onClick={() => onCheckOne(item)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className='search-main-advanced-checkbox'>
                            <label>
                                <Checkbox checked={isCheckTotalTwo} onClick={onClickTotalTwo}/>
                                4〜6回
                            </label>
                        </div>
                        <div className='search-main-analysis-child-item wrap-group'>
                            {twoList.map(item => {
                                return (
                                    <div key={item.id} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.check} onClick={() => onCheckTwo(item)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className='search-main-advanced-checkbox'>
                            <label>
                                <Checkbox checked={isCheckTotalThird} onClick={onClickTotalThird}/>
                                7〜9回
                            </label>
                        </div>
                        <div className='search-main-analysis-child-item wrap-group'>
                            {threeList.map(item => {
                                return (
                                    <div key={item.id} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.check} onClick={() => onCheckThird(item)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
            </div>

        </div>
    )
}

export default Inning;
